var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSentEmail = function SvgSentEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sent-email_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 19v3l6-5.5-6-5.5v3h-7v5z",
    className: "sent-email_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16H2a1.5 1.5 0 0 1-1.5-1.5v-11A1.5 1.5 0 0 1 2 2h18a1.5 1.5 0 0 1 1.5 1.5V10",
    className: "sent-email_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.067 2.446 11 10.5.933 2.446",
    className: "sent-email_svg__a"
  })));
};
export default SvgSentEmail;